import AppNexusConfig from './AppNexusConfig'

export default AppNexusConfig
